import { Box, Divider, Typography } from "@mui/material";

const CustomDivider = ({item, ...props}) =>{

    return(
        <>
            <Box>
                <Divider flexItem {...item?.props} />
            </Box>
        </>
    )
}
export default CustomDivider;